export type BenefitId = Branded<string, 'benefitId'>;

export type BenefitCta = {
  label: string;
  link: string;
};

export interface Benefit {
  id: BenefitId;
  name: string;
  description: string;
  content: string;
  sequence: number;
  published: boolean;
  image: string | null;
  logo: string | null;
  detailImage: string | null;
  discount: string;
  ctas: BenefitCta[];
}

export interface BenefitDto {
  id: BenefitId;
  name: string;
  description: string | null;
  content: string | null;
  sequence: number;
  published: boolean;
  image: { url: string } | null;
  logo: { url: string } | null;
  detailImage: { url: string } | null;
  discount: string | null;
  ctas?: Array<{
    label: string;
    link: string;
    sequence: number;
  }>;
}

export class BenefitModel {
  static fromDto = (dto: BenefitDto): Benefit => ({
    id: dto.id,
    name: dto.name,
    description: dto.description ?? '',
    content: dto.content ?? '',
    sequence: dto.sequence,
    published: dto.published,
    image: dto.image?.url ?? null,
    logo: dto.logo?.url ?? null,
    detailImage: dto.detailImage?.url ?? null,
    discount: dto.discount ?? '',
    ctas: [...(dto.ctas ?? [])]
      .sort((a, b) => a.sequence - b.sequence)
      .map(({ label, link }) => ({
        label: label ?? '',
        link: link ?? '',
      })),
  });
}
